import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "../pages/Login.vue";
import PasswordReset from "../pages/PasswordReset.vue";
import Index from "../pages/Index.vue";
import EmployeesList from "../pages/EmployeesList.vue";
import SyncHistoriesList from "../pages/SyncHistoriesList.vue";
import OperationLogsCSV from "../pages/OperationLogsCSV.vue";
import { Auth } from "aws-amplify";

Vue.use(VueRouter);

import * as CONSTANTS from "../common/constants";

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: Index,
    redirect: { name: CONSTANTS.ROUTE_NAME.EMPLOYEES_LIST },
    meta: { requiresAuth: true }, // 要ログイン
    children: [
      {
        path: "employees",
        name: CONSTANTS.ROUTE_NAME.EMPLOYEES_LIST,
        component: EmployeesList,
        meta: { requiresAuth: true }, // 要ログイン
      },
      {
        path: "sync/histories",
        name: CONSTANTS.ROUTE_NAME.SYNC_HISTORIES_LIST,
        component: SyncHistoriesList,
        meta: { requiresAuth: true }, // 要ログイン
      },
      {
        path: "csv/operation-logs",
        name: CONSTANTS.ROUTE_NAME.OPERATION_LOGS_CSV,
        component: OperationLogsCSV,
        meta: { requiresAuth: true }, // 要ログイン
      },
    ],
  },
  {
    path: "/login",
    name: CONSTANTS.ROUTE_NAME.LOGIN,
    component: Login,
  },
  {
    path: "/password",
    name: CONSTANTS.ROUTE_NAME.PASSWORD_RESET,
    component: PasswordReset,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const currentUser = await Auth.currentUserInfo();
    if (!currentUser || !currentUser.username) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else if (to.matched.length === 0) {
    // 存在しないURLの場合はTOPへ遷移
    next({
      path: "/",
    });
  } else {
    next();
  }
});

export default router;
